import React from 'react';

import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';

export const matchColortoIcon = ({ valueIcon }) => {
  let color;

  if (valueIcon === 0) {
    color = '#61a460';
  } else if (valueIcon === 1) {
    color = '#d29f3d';
  } else if (valueIcon === 2) {
    color = '#dd3d7b';
  } else {
    color = '#ffffff';
  }

  return color;
};

export const remappedRubricsToChecks = ({ masteryLevel, color }) => {
  switch (masteryLevel) {
    case 0:
      return <CheckCircleIcon htmlColor={color} />;
    case 1:
      return <ErrorIcon htmlColor={color} />;
    case 2:
      return <CancelIcon htmlColor={color} />;
    default:
      return null;
  }
};
